module.exports = new __parcel__URL__("my-near-wallet-icon.ff4757f7.png").toString();